import { Component } from '@angular/core';
import * as $ from 'jquery'
@Component({
    selector: "page-tabs_cert",
    templateUrl: "./tabs_cert.component.html"
})

export class Tabs_certComponent {
    public circleMenu;
    public formId
    public actualForm;
    constructor(){
    $('.nav-tabs > li a[title]');
    
    //Wizard
    $('a[data-toggle="tab"]').on('show.bs.tab',  (e) => {

        var $target = $(e.target);
    
        if ($target.parent().hasClass('disabled')) {
            return false;
        }
    });
    $(".next-step").click( (e) => {

        var $active = $('.wizard .steps .nav-tabs li.active');
        
        $active.next().removeClass('disabled');
        //console.log('disableeee');
        this.nextTab($active);
        //console.log('active.next: ' + $active.next());
        //console.log('nextTab: ' + nextTab($active));

    });
    $(".prev-step").click( (e) => {

        var $active = $('.wizard .steps .nav-tabs li.active');
        this.prevTab($active);

    });
    
    $('[id^=detail-]').hide();
    $('.toggle').click(function() {
        var $input = $( this );
        var $target = $('#'+$input.attr('data-toggle'));
        $target.slideToggle();
    });	

    this.circleMenu =[
        {
           "number": 1,
           "icon": "glyphicon glyphicon-home",
           "active": "active" 
        },
        {
            "number": 2,
            "icon": "glyphicon glyphicon-folder-open",
            "active": "disabled"
        },
        {
            "number": 3,
            "icon": "glyphicon glyphicon-list-alt",
            "active": "disabled"
        },
        {
            "number": 4,
            "icon": "glyphicon glyphicon-level-up",
            "active": "disabled"
        }]
    
}

 nextTab(elem) {
    $(elem).next().find('a[data-toggle="tab"]').click();
    //console.log('nextTab: ' + $(elem).next().find('a[data-toggle="tab"]'));
}
 prevTab(elem) {
    $(elem).prev().find('a[data-toggle="tab"]').click();
}

}
